import React, { useState, useEffect } from 'react';

const EventAccessRules = ({ eventId: propEventId }) => {
  const [accessRules, setAccessRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    opens_at: '',
    closes_at: '',
    access_type: 'open_all',
    criteria: {},
    max_registrations: ''
  });
  const [clubs, setClubs] = useState([]);

  const getEventId = () => {
    if (propEventId) return propEventId;
    const urlPath = window.location.pathname;
    const match = urlPath.match(/\/events\/(\d+)/);
    return match ? match[1] : null;
  };

  const eventId = getEventId();

  const accessTypeLabels = {
    'user_list': '👥 Liste d\'utilisateurs spécifiques',
    'user_level': '⭐ Par niveau d\'adhésion',
    'club_members': '🏛️ Membres de clubs',
    'open_all': '🌍 Ouvert à tous'
  };

  const userLevels = [
    { value: 'invite', label: 'Invité' },
    { value: 'adherent_sympathisant', label: 'Adhérent Sympathisant' },
    { value: 'adherent_participant', label: 'Adhérent Participant' },
    { value: 'adherent_actif', label: 'Adhérent Actif' },
    { value: 'membre_fondateur', label: 'Membre Fondateur' }
  ];

  useEffect(() => {
    if (eventId) {
      loadAccessRules();
      loadClubs();
    }
  }, [eventId]);

  const loadAccessRules = async () => {
    try {
      setLoading(true);
      const response = await fetch(`/api/v1/events/${eventId}/access_rules`, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      });

      const data = await response.json();
      if (data.success) {
        setAccessRules(data.access_rules);
      }
    } catch (error) {
      console.error('Erreur chargement vagues:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadClubs = async () => {
    try {
      const response = await fetch('/api/v1/clubs', {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      });
      const data = await response.json();
      if (data.success) {
        setClubs(data.clubs || []);
      }
    } catch (error) {
      console.error('Erreur chargement clubs:', error);
    }
  };

  const handleCreateAccessRule = async () => {
    if (!formData.name || !formData.opens_at) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    try {
      const response = await fetch(`/api/v1/events/${eventId}/access_rules`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (data.success) {
        alert('✅ Vague d\'accès créée');
        setShowAddModal(false);
        resetForm();
        loadAccessRules();
      } else {
        alert(`❌ ${data.message}`);
      }
    } catch (error) {
      console.error('Erreur création vague:', error);
      alert('❌ Erreur lors de la création');
    }
  };

  const handleDeleteAccessRule = async (ruleId) => {
    if (!confirm('Êtes-vous sûr de vouloir supprimer cette vague ?')) return;

    try {
      const response = await fetch(`/api/v1/events/${eventId}/access_rules/${ruleId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      });

      const data = await response.json();
      if (data.success) {
        alert('✅ Vague supprimée');
        loadAccessRules();
      } else {
        alert(`❌ ${data.message}`);
      }
    } catch (error) {
      console.error('Erreur suppression:', error);
      alert('❌ Erreur lors de la suppression');
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      opens_at: '',
      closes_at: '',
      access_type: 'open_all',
      criteria: {},
      max_registrations: ''
    });
  };

  const getStatusBadge = (rule) => {
    if (rule.is_active) {
      return { text: '🟢 Active', color: '#15803d' };
    } else if (rule.is_upcoming) {
      return { text: '⏳ À venir', color: '#f59e0b' };
    } else if (rule.is_closed) {
      return { text: '⛔ Fermée', color: '#ef4444' };
    } else {
      return { text: rule.status, color: '#9e6575' };
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '160px 40px 40px', minHeight: '100vh', background: '#f7eef2' }}>
        <div style={{ color: '#fff', textAlign: 'center', fontSize: '1.2rem' }}>
          Chargement...
        </div>
      </div>
    );
  }

  return (
    <div className="event-mobile-shell event-access-rules-page" style={{ padding: '160px 40px 40px', minHeight: '100vh', background: '#f7eef2' }}>
      <div className="event-mobile-container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div className="event-page-header" style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '40px'
        }}>
          <div>
            <h1 style={{
              color: '#fff',
              fontSize: 'clamp(2rem, 4vw, 2.5rem)',
              fontWeight: '800',
              marginBottom: '8px'
            }}>
              Vagues d'Accès
            </h1>
            <p style={{ color: '#9e6575', fontSize: '1rem' }}>
              Gérez l'ouverture progressive des inscriptions
            </p>
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            style={{
              background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              padding: '14px 28px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(124, 40, 55, 0.3)'
            }}
          >
            ➕ Ajouter une vague
          </button>
        </div>

        {/* Timeline des vagues */}
        {accessRules.length > 0 ? (
          <div className="event-access-rules-timeline" style={{ position: 'relative', paddingLeft: '40px' }}>
            {/* Ligne verticale */}
            <div className="event-access-rules-timeline-line" style={{
              position: 'absolute',
              left: '16px',
              top: '30px',
              bottom: '30px',
              width: '2px',
              background: 'rgba(124, 40, 55, 0.3)'
            }} />

            {accessRules.map((rule, index) => {
              const status = getStatusBadge(rule);
              return (
                <div
                  key={rule.id}
                  style={{
                    background: '#ffffff',
                    borderRadius: '16px',
                    padding: '24px',
                    border: '1px solid rgba(124, 40, 55, 0.2)',
                    marginBottom: '24px',
                    position: 'relative',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(124, 40, 55, 0.5)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(124, 40, 55, 0.2)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  {/* Dot sur la timeline */}
                  <div className="event-access-rule-dot" style={{
                    position: 'absolute',
                    left: '-32px',
                    top: '30px',
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    background: status.color,
                    border: '3px solid #0a0a0a'
                  }} />

                  <div className="event-access-rule-card-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      {/* Header */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                        <span style={{
                          background: 'rgba(124, 40, 55, 0.25)',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          color: '#943143',
                          border: '1px solid rgba(168,56,78,0.35)'
                        }}>
                          Priorité {rule.priority}
                        </span>
                        <span style={{ color: status.color, fontSize: '0.9rem', fontWeight: '600' }}>
                          {status.text}
                        </span>
                      </div>

                      <h3 style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700', marginBottom: '8px' }}>
                        {rule.name}
                      </h3>
                      {rule.description && (
                        <p style={{ color: '#9e6575', fontSize: '0.95rem', marginBottom: '16px' }}>
                          {rule.description}
                        </p>
                      )}

                      {/* Type d'accès */}
                      <div style={{
                        background: '#fdf6f8',
                        padding: '12px 16px',
                        borderRadius: '8px',
                        marginBottom: '16px'
                      }}>
                        <div style={{ color: '#fff', fontWeight: '600', marginBottom: '4px' }}>
                          {accessTypeLabels[rule.access_type]}
                        </div>
                        {rule.access_type === 'user_level' && rule.criteria.levels && (
                          <div style={{ color: '#9e6575', fontSize: '0.9rem' }}>
                            Niveaux : {rule.criteria.levels.join(', ')}
                          </div>
                        )}
                        {rule.access_type === 'club_members' && rule.criteria.club_ids && (
                          <div style={{ color: '#9e6575', fontSize: '0.9rem' }}>
                            {rule.criteria.club_ids.length} club(s) autorisé(s)
                          </div>
                        )}
                        {rule.access_type === 'user_list' && rule.criteria.user_ids && (
                          <div style={{ color: '#9e6575', fontSize: '0.9rem' }}>
                            {rule.criteria.user_ids.length} utilisateur(s) spécifique(s)
                          </div>
                        )}
                      </div>

                      {/* Dates */}
                      <div className="event-access-rule-dates" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                        <div>
                          <div style={{ color: '#9e6575', fontSize: '0.85rem', marginBottom: '4px' }}>
                            📅 Ouverture
                          </div>
                          <div style={{ color: '#fff', fontWeight: '600' }}>
                            {new Date(rule.opens_at).toLocaleDateString('fr-FR', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                        </div>
                        {rule.closes_at && (
                          <div>
                            <div style={{ color: '#9e6575', fontSize: '0.85rem', marginBottom: '4px' }}>
                              🔒 Fermeture
                            </div>
                            <div style={{ color: '#fff', fontWeight: '600' }}>
                              {new Date(rule.closes_at).toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Stats */}
                      {rule.max_registrations && (
                        <div style={{
                          background: '#fdf6f8',
                          padding: '12px 16px',
                          borderRadius: '8px'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                            <span style={{ color: '#9e6575', fontSize: '0.9rem' }}>Inscriptions</span>
                            <span style={{ color: '#fff', fontWeight: '600' }}>
                              {rule.registrations_count} / {rule.max_registrations}
                            </span>
                          </div>
                          <div style={{
                            width: '100%',
                            height: '6px',
                            background: 'rgba(124, 40, 55, 0.2)',
                            borderRadius: '3px',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              width: `${rule.percentage_filled}%`,
                              height: '100%',
                              background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
                              transition: 'width 0.3s ease'
                            }} />
                          </div>
                          {rule.spots_remaining !== null && (
                            <div style={{ color: '#9e6575', fontSize: '0.85rem', marginTop: '4px' }}>
                              {rule.spots_remaining} place(s) restante(s)
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Actions */}
                    <button
                      onClick={() => handleDeleteAccessRule(rule.id)}
                      style={{
                        background: 'rgba(239, 68, 68, 0.1)',
                        border: '1px solid rgba(239, 68, 68, 0.3)',
                        color: '#ef4444',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        marginLeft: '16px'
                      }}
                    >
                      🗑️
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{
            background: '#ffffff',
            borderRadius: '16px',
            padding: '60px 40px',
            textAlign: 'center',
            border: '2px dashed rgba(124, 40, 55, 0.2)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🌊</div>
            <h3 style={{ color: '#fff', fontSize: '1.3rem', fontWeight: '700', marginBottom: '8px' }}>
              Aucune vague configurée
            </h3>
            <p style={{ color: '#9e6575', fontSize: '1rem', marginBottom: '24px' }}>
              Créez des vagues d'accès pour contrôler qui peut s'inscrire et quand
            </p>
            <button
              onClick={() => setShowAddModal(true)}
              style={{
                background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '12px',
                padding: '14px 28px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Créer la première vague
            </button>
          </div>
        )}

        {/* Modal Ajout */}
        {showAddModal && (
          <div className="event-detail-modal" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}>
            <div className="event-modal-card" style={{
              background: '#ffffff',
              borderRadius: '20px',
              padding: '32px',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              border: '1px solid rgba(124, 40, 55, 0.2)'
            }}>
              <h2 style={{ color: '#fff', fontSize: '1.8rem', fontWeight: '800', marginBottom: '24px' }}>
                Nouvelle vague d'accès
              </h2>

              {/* Nom */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Nom de la vague *
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  placeholder="Ex: Membres fondateurs"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#fdf6f8',
                    border: '1px solid rgba(124, 40, 55, 0.2)',
                    borderRadius: '8px',
                    color: '#fff',
                    fontSize: '1rem'
                  }}
                />
              </div>

              {/* Description */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Description
                </label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  placeholder="Description optionnelle..."
                  rows="3"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#fdf6f8',
                    border: '1px solid rgba(124, 40, 55, 0.2)',
                    borderRadius: '8px',
                    color: '#fff',
                    fontSize: '1rem',
                    resize: 'vertical'
                  }}
                />
              </div>

              {/* Type d'accès */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Type d'accès *
                </label>
                <select
                  value={formData.access_type}
                  onChange={(e) => setFormData({...formData, access_type: e.target.value, criteria: {}})}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#fdf6f8',
                    border: '1px solid rgba(124, 40, 55, 0.2)',
                    borderRadius: '8px',
                    color: '#fff',
                    fontSize: '1rem'
                  }}
                >
                  {Object.entries(accessTypeLabels).map(([value, label]) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </select>
              </div>

              {/* Critères selon le type */}
              {formData.access_type === 'user_level' && (
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Niveaux autorisés
                  </label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {userLevels.map(level => (
                      <label key={level.value} style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px',
                        background: '#fdf6f8',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        border: '1px solid rgba(124, 40, 55, 0.2)'
                      }}>
                        <input
                          type="checkbox"
                          checked={formData.criteria.levels?.includes(level.value)}
                          onChange={(e) => {
                            const levels = formData.criteria.levels || [];
                            if (e.target.checked) {
                              setFormData({
                                ...formData,
                                criteria: { levels: [...levels, level.value] }
                              });
                            } else {
                              setFormData({
                                ...formData,
                                criteria: { levels: levels.filter(l => l !== level.value) }
                              });
                            }
                          }}
                          style={{ marginRight: '12px' }}
                        />
                        <span style={{ color: '#fff' }}>{level.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {/* Dates */}
              <div className="event-modal-two-col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                <div>
                  <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Date d'ouverture *
                  </label>
                  <input
                    type="datetime-local"
                    value={formData.opens_at}
                    onChange={(e) => setFormData({...formData, opens_at: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      background: '#fdf6f8',
                      border: '1px solid rgba(124, 40, 55, 0.2)',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                <div>
                  <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Date de fermeture
                  </label>
                  <input
                    type="datetime-local"
                    value={formData.closes_at}
                    onChange={(e) => setFormData({...formData, closes_at: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      background: '#fdf6f8',
                      border: '1px solid rgba(124, 40, 55, 0.2)',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: '1rem'
                    }}
                  />
                </div>
              </div>

              {/* Quota */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{ color: '#fff', display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Quota maximum (optionnel)
                </label>
                <input
                  type="number"
                  value={formData.max_registrations}
                  onChange={(e) => setFormData({...formData, max_registrations: e.target.value})}
                  placeholder="Laisser vide = illimité"
                  min="1"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#fdf6f8',
                    border: '1px solid rgba(124, 40, 55, 0.2)',
                    borderRadius: '8px',
                    color: '#fff',
                    fontSize: '1rem'
                  }}
                />
              </div>

              {/* Actions */}
              <div className="event-modal-actions" style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                  style={{
                    background: 'transparent',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: '#fff',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    fontWeight: '600'
                  }}
                >
                  Annuler
                </button>
                <button
                  onClick={handleCreateAccessRule}
                  style={{
                    background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
                    border: 'none',
                    color: '#fff',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    fontWeight: '600'
                  }}
                >
                  Créer la vague
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventAccessRules;
